import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { apiGetOneClientSeminar } from '../../../../actions/ClientSeminarActions';
import { wrapDispatch } from '../../../../helpers/action';
const ClientSeminarOneHoc = (setting, ChildSkeletonComponent) => (ChildComponent) => {
    const ClientSeminarOneHocInner = (props) => {
        const { redirectCallback } = setting;
        const { match: { params: { id }, }, } = props;
        const [loading, changeLoading] = useState(!!id);
        const dispatch = useDispatch();
        const seminar = useSelector((state) => state.clientSeminar.one[id]);
        const profile = useSelector((state) => state.profile);
        const redirectTo = useMemo(() => {
            if (!loading && !seminar && id)
                return '/error/notfound';
            if (seminar && redirectCallback)
                return redirectCallback(seminar);
            return '';
        }, [id, seminar, loading, redirectCallback]);
        useEffect(() => {
            let unmount = false;
            if (id) {
                changeLoading(true);
                wrapDispatch(dispatch, apiGetOneClientSeminar(id, { id })).finally(() => {
                    if (!unmount) {
                        changeLoading(false);
                    }
                });
            }
            return () => {
                unmount = true;
            };
        }, [id, dispatch, changeLoading]);
        if (redirectTo) {
            return _jsx(CustomRedirect, { to: redirectTo });
        }
        if (loading && !seminar) {
            return _jsx(ChildSkeletonComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props, { profile: profile, seminar: seminar }));
    };
    ClientSeminarOneHocInner.propTypes = {
        match: propMatch(),
    };
    return ClientSeminarOneHocInner;
};
export default ClientSeminarOneHoc;
